export type DestinationSlug =
  | 'new-york-city'
  | 'jfk-airport'
  | 'london'
  | 'london-heathrow'
  | 'tokyo'
  | 'dubai'
  | 'business-travel-orchestration';

// The footer and the home page import this file, so it stays small: names,
// one-line summaries and links. Each page's full guide is in
// destination-guides.ts, which only the destination route loads.
// scripts/prerender.mjs and vite.config.ts pull every quoted slug value out
// of this file with a regex to build the route and sitemap lists, so never
// write one in a comment.
export interface Destination {
  slug: DestinationSlug;
  name: string;
  country: string;
  category: 'city' | 'airport' | 'business-hub' | 'itinerary';
  // One line for cards and listings, never the guide's opening paragraph.
  summary: string;
  coordinates: { lat: number; lon: number };
  relatedSlugs: DestinationSlug[];
}

export const destinations: Destination[] = [
  {
    slug: 'new-york-city',
    name: 'New York City',
    country: 'USA',
    category: 'city',
    summary: 'JFK, LaGuardia and Newark, the subway and commuter rail, and keeping a New York trip in step.',
    coordinates: { lat: 40.71, lon: -74.00 },
    relatedSlugs: ['jfk-airport', 'london', 'tokyo']
  },
  {
    slug: 'jfk-airport',
    name: 'John F. Kennedy International (JFK)',
    country: 'USA',
    category: 'airport',
    summary: "New York's main international gateway: separate terminals, AirTrain JFK and the roads into the city.",
    coordinates: { lat: 40.64, lon: -73.77 },
    relatedSlugs: ['new-york-city', 'london-heathrow', 'business-travel-orchestration']
  },
  {
    slug: 'london',
    name: 'London',
    country: 'UK',
    category: 'city',
    summary: 'Six airports, the Elizabeth line and Eurostar: getting into and around London on business.',
    coordinates: { lat: 51.50, lon: -0.12 },
    relatedSlugs: ['london-heathrow', 'new-york-city', 'dubai']
  },
  {
    slug: 'london-heathrow',
    name: 'London Heathrow (LHR)',
    country: 'UK',
    category: 'airport',
    summary: 'Four terminals, three rail links into London and airside transfers for connecting flights.',
    coordinates: { lat: 51.47, lon: -0.45 },
    relatedSlugs: ['london', 'jfk-airport', 'business-travel-orchestration']
  },
  {
    slug: 'tokyo',
    name: 'Tokyo',
    country: 'Japan',
    category: 'city',
    summary: 'Haneda or Narita, Suica and PASMO, the Shinkansen and the last train of the night.',
    coordinates: { lat: 35.67, lon: 139.65 },
    relatedSlugs: ['new-york-city', 'london', 'dubai']
  },
  {
    slug: 'dubai',
    name: 'Dubai',
    country: 'UAE',
    category: 'city',
    summary: 'DXB and Al Maktoum, the Metro Red Line and planning meetings around traffic and heat.',
    coordinates: { lat: 25.20, lon: 55.27 },
    relatedSlugs: ['london', 'tokyo', 'business-travel-orchestration']
  },
  {
    slug: 'business-travel-orchestration',
    name: 'Business Travel Orchestration',
    country: 'Global',
    category: 'itinerary',
    summary: 'A New York, London and Dubai trip run as one plan across three time zones.',
    coordinates: { lat: 20.00, lon: 0.00 },
    relatedSlugs: ['new-york-city', 'london', 'dubai']
  }
];
